import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["active", "children", "invalid", "size", "style"];
import * as React from 'react';
import classNames from 'classnames';
import { ArrowDownIcon } from '../../icons';
import * as styles from './selectButton.css';
import { EVisualSize } from '../types';
import { getInlineStyles } from './helpers';
export var SelectButton = function SelectButton(_ref) {
  var active = _ref.active,
      children = _ref.children,
      invalid = _ref.invalid,
      size = _ref.size,
      style = _ref.style,
      htmlButtonProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("button", _extends({}, htmlButtonProps, {
    type: "button",
    className: classNames(styles['button'], active && styles['active'], invalid && styles['invalid'], size === EVisualSize.DESKTOP && styles['desktop'], size === EVisualSize.MOBILE && styles['mobile']),
    style: getInlineStyles(style)
  }), /*#__PURE__*/React.createElement("span", {
    className: styles['content']
  }, children), /*#__PURE__*/React.createElement(ArrowDownIcon, {
    __classNames: classNames(styles['icon']),
    custom: {
      size: '11'
    },
    styles: {
      color: htmlButtonProps.disabled ? 'C9C9C9' : '2B87DB'
    }
  }));
};